import { useMemo, useCallback } from 'react';
import _ from 'lodash';
import GeneralTabFieldsTable from './GeneralTabFieldsTable';
import { Grid, Typography } from '@ts/storybook';
import AvatarImage from '@components/Entities/AvatarImage';
import { IForm, TMode } from '@ts/ui-models';
import { CDocument, CElementType, IIcon } from '@ts/ui-models';
import { NewPaperWithPadding } from '@components/Misc';
import IconSelectorInputModal from '@components/Inputs/IconSelectorInputModal';

interface IItemTypeTabProps extends IForm {
  values: CElementType;
  rows?: any[];
}

const ItemTypeTab = (props: IItemTypeTabProps) => {
  const { mode, values, rows, onCallbackChange } = props;
  const isViewMode = mode === 'view';

  const defaultRows = useMemo(() => [], []);

  const checkBoxValue = useCallback(
    (attrPath: string, attr: any) => {
      const attrContainer = _.get(values, attrPath);
      if (Array.isArray(attrContainer)) {
        return attrContainer.includes(attr);
      }
      return false;
    },
    [values]
  );

  const onChangeCheckBox = useCallback(
    ({ attrPath, attr }: { attrPath: string; attr: any }, value: boolean) => {
      const prevArray = values[attrPath] || [];
      const attrArray = value ? [...prevArray, attr] : prevArray.filter((attr0: any) => attr0 !== attr);

      onCallbackChange(attrPath)(attrArray);

      if (attrPath === 'attrsLocked' && value) {
        const prevAttrsReadOnly = values.attrsReadOnly || [];
        const attrsReadOnly = [...prevAttrsReadOnly, attr];
        onCallbackChange('attrsReadOnly')(attrsReadOnly);
      }

      if (attrPath === 'attrsSeriable' && !value) {
        onCallbackChange('seriesConfig')(null);
      }
    },
    [values, onCallbackChange]
  );

  const handleUploadPhotoSuccess = (image: CDocument | null) => {
    onCallbackChange('document')(image);
  };
  const onChangeDefaultIcon = useCallback(
    (icon: Partial<IIcon> | null) => {
      onCallbackChange('icon')(icon);
    },
    [onCallbackChange]
  );

  return (
    <Grid container size={12} spacing={2}>
      <Grid size={12}>
        <GeneralTabFieldsTable
          {...props}
          rows={rows || defaultRows}
          fnCheckBoxValue={checkBoxValue}
          fnOnChangeCheckBox={onChangeCheckBox}
          disabled={isViewMode}
        />
      </Grid>
      <Grid size={12}>
        <NewPaperWithPadding withoutScroll>
          <Grid container size={12} direction={'column'} sx={{ justifyContent: 'flex-start' }} spacing={2}>
            <Typography variant="h6" text={'Visualization'} />

            <Grid container direction={'row'} size={{ xs: 12, sm: 12, md: 4 }} spacing={2} alignItems="center">
              <Typography variant="body1" text={'Default icon'} />
              <IconSelectorInputModal
                isViewMode={isViewMode}
                onSelectIcon={onChangeDefaultIcon}
                selectedIcon={values.getIcon()}
                withoutClear
              />
            </Grid>
            <Grid container direction={'row'} size={{ xs: 12, sm: 12, md: 4 }} spacing={2} alignItems="center">
              <Typography variant="body1" text={'Default avatar'} />
              <AvatarImage
                mode={mode}
                cEntity={values}
                image={values.getAvatar()}
                onUploadedPhoto={handleUploadPhotoSuccess}
                onClearImage={() => handleUploadPhotoSuccess(null)}
                entityTypeId="tsElementType"
                entityId={values.getID()}
              />
            </Grid>
          </Grid>
        </NewPaperWithPadding>
      </Grid>
    </Grid>
  );
};

export default ItemTypeTab;
